import { module as m } from 'modujs';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);

        this.hidden = true;

        gsap.set(this.el, {
            y: '100%',
            autoAlpha: 1,
            visibility: 'visible'
        });
    }

    init() {}

    /**
     * SHOW
     * @private
     */
    show() {
        if (this.hidden) {
            this.hidden = false;
            gsap.to(this.el, {
                y: 0,
                rotation: 0.1,
                duration: 1,
                ease: 'power4.out',
                overwrite: true
            });
        }
    }

    /**
     * HIDE
     * @private
     */
    hide() {
        if (!this.hidden) {
            this.hidden = true;
            gsap.to(this.el, {
                y: '100%',
                rotation: 0.1,
                duration: 1,
                ease: 'power4.out',
                overwrite: true
            });
        }
    }
}
